/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInsuranceRulesRequestRulesInner
 */
export interface UpdateInsuranceRulesRequestRulesInner {
    /**
     * Catalog rule type; unknown values are rejected with 400.
     */
    rule_type: string;
    /**
     * 
     */
    qualifier: UpdateInsuranceRulesRequestRulesInnerQualifierEnum;
    /**
     * Must be null for rules without a threshold, otherwise within [threshold_min, threshold_max].
     */
    threshold: number | null;
}


/**
 * @export
 */
export const UpdateInsuranceRulesRequestRulesInnerQualifierEnum = {
    DealBreaker: 'Deal Breaker',
    Warning: 'Warning',
} as const;
export type UpdateInsuranceRulesRequestRulesInnerQualifierEnum = typeof UpdateInsuranceRulesRequestRulesInnerQualifierEnum[keyof typeof UpdateInsuranceRulesRequestRulesInnerQualifierEnum];


/**
 * Check if a given object implements the UpdateInsuranceRulesRequestRulesInner interface.
 */
export function instanceOfUpdateInsuranceRulesRequestRulesInner(value: object): value is UpdateInsuranceRulesRequestRulesInner {
    if (!('rule_type' in value) || value['rule_type'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    return true;
}

export function UpdateInsuranceRulesRequestRulesInnerFromJSON(json: any): UpdateInsuranceRulesRequestRulesInner {
    return UpdateInsuranceRulesRequestRulesInnerFromJSONTyped(json, false);
}

export function UpdateInsuranceRulesRequestRulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInsuranceRulesRequestRulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'rule_type': json['rule_type'],
        'qualifier': json['qualifier'],
        'threshold': json['threshold'],
    };
}

export function UpdateInsuranceRulesRequestRulesInnerToJSON(json: any): UpdateInsuranceRulesRequestRulesInner {
    return UpdateInsuranceRulesRequestRulesInnerToJSONTyped(json, false);
}

export function UpdateInsuranceRulesRequestRulesInnerToJSONTyped(value?: UpdateInsuranceRulesRequestRulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule_type': value['rule_type'],
        'qualifier': value['qualifier'],
        'threshold': value['threshold'],
    };
}

